import { History } from 'history';
import { action, observable } from 'mobx';
import { Env } from 'src/core/Environment';
import { Router } from 'src/core/router/Router';
import { configureMobX } from 'src/mobXSettings';
import { AgentProfileStore } from 'src/stores/AgentProfileStore/AgentProfileStore';
import { AuthStore } from 'src/stores/AuthStore/AuthStore';
import { SettingsStore } from 'src/stores/SettingsStore/SettingsStore';
import { UserStore } from 'src/stores/UserStore/UserStore';

export class AppStoreClass {
    @observable started = false;

    @action
    async init() {
        configureMobX();
        await SettingsStore.load();

        if (SettingsStore.hasSettings) {
            await SettingsStore.setupInternationalization();
            SettingsStore.setupKeycloak();
            await AuthStore.authenticate();
        }
        if (AuthStore.authenticated) {
            await UserStore.loadUserInfo();
        }

        if (AuthStore.authenticated && Env.isAgentPortal) {
            await AgentProfileStore.loadItem('');
        }
    }

    setHistory(history: History) {
        Router.setHistory(history);
        this.started = true;
    }
}

export const AppStore = new AppStoreClass();
